import { useState, useContext } from 'react'
import {FaSearch} from 'react-icons/fa'
import GithubContext from '../../context/github/GithubContext'
import AlertContext from '../../context/alert/AlertContext'
import { searchUsers } from '../../context/github/GithubActions'
import Illustration from '../../assets/illustration.svg'

function UserSearch() {
  const [ text , setText ] = useState('')
  
  const { users, dispatch, loading } = useContext(GithubContext)
  const { setAlert } = useContext(AlertContext)

  const handleChange = (e) => setText(e.target.value)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if(text === ''){
      setAlert('Please enter a text', 'error')
    }else{
      dispatch({type: 'SET_LOADING', payload: true})

      const users = await searchUsers(text)
      dispatch({type: 'GET_USERS', payload: users})
      setText('')
    }
  }
  

  return (
    <div className='flex container justify-around flex-col lg:flex-row items-center mb-8'>
      <div className="flex flex-col grow max-w-prose md:flex-row mb-8 mb:m-8 order-2 lg:order-1">
        <div className='w-full shadow-2xl'>
          <form onSubmit={handleSubmit}>
            <div className="form-control">
              <div className="relative">
                <input 
                  type="text" 
                  className="w-full pr-16 bg-gray-200 input input-lg text-black tracking-wide" 
                  placeholder="search developers..."
                  value={text}
                  onChange={handleChange}
                />

                <button className="absolute top-0 right-0 rounded-l-none w-20 md:w-28 btn btn-lg btn-primary">
                  <FaSearch />
                </button>
              </div>
            </div>
          </form>
        </div>
        
        {users.length > 0 && (
            <div>
              <button onClick={() => dispatch({type: 'CLEAR_USERS'})} className="btn btn-ghost btn-lg mx-3 my-3 md:my-0">Clear</button>
            </div>
        )}
        
      </div>

      <div className='m-8 illustration order-1 lg:order-2'>
          <img className={(!loading && users.length <= 0) ? 'w-full max-w-xs lg:max-w-md' : 'w-0'} src={Illustration} alt="Developer Illustration" />
      </div>
    </div>
  )
} 

export default UserSearch